import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";

import PrestadorService from '../../service/PrestadorService';

const prestadorService = new PrestadorService(); // Create an instance of PrestadorService

const ListarTipoPrestador = () => {
    const [tipoPrestador, setTipoPrestador] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [tipo, setTipoParaDeletar] = useState(null);

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));

    useEffect(() => {
        initFilters1();
        initTipoPrestador();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const initTipoPrestador = () => {
        setLoading1(true);
        prestadorService.listAllTipoPrestador(iss).then(data => {
            setTipoPrestador(data.data.rows);
            setLoading1(false);
        });
    }

    const initFilters1 = () => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'descricao': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    const irParaCadastro = () => {
        if (roles.postTipoPrestador)
            history.push('/prestador/tipo/cadastrar');
    }

    const abreModalDeletar = (tipo) => {
        console.log(tipo);
        setTipoParaDeletar(tipo);
        setDeleteDialog(true);
    }

    const handleDeleteTipo = () => {
        if (roles.deleteTipoPrestador) {
            setLoading1(true)
            prestadorService.deleteTipoPrestador(iss, tipo.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Tipo excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initTipoPrestador();
            });
        }
    }

    const editar = (tipoParaEditar) => {
        if (roles.getTipoPrestador)
            history.push('/prestador/tipo/editar/' + tipoParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setTipoParaDeletar(null);
    }

    const ativoBody = (rowData) => {
        return <span className="p-inputgroup-addon p-inputgroup-addon-checkbox"><Checkbox checked={rowData.ativo} disabled binary /></span>
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {roles.deleteTipoPrestador ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {roles.getTipoPrestador ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTipo} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {roles.postTipoPrestador ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Tipo Prestador</h5>
                    <DataTable value={tipoPrestador} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma prestador cadastrado.">
                        <Column sortable field="nome" header="Nome" filter filterPlaceholder="Procurar por nome" style={{ minWidth: '12rem' }} />
                        <Column sortable field="descricao" header="CPF" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="status" body={ativoBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir o tipo de prestador selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarTipoPrestador, comparisonFn);
